{"version":"26.10.27-local-solo","id":"at.softline.lagerhaus.freistadt.softline","name":"Lagerhaus Freistadt Softline"}